import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import FullScreenLoader from "./FullScreenLoader";
import { getLandingPath } from "../utils/landing-path";

export default function PublicRoute({ children }) {
  const { user, loading, allowedPaths } = useContext(AuthContext);

  if (loading) {
    // After a successful login we reload onto this same /login URL before
    // redirecting to the dashboard. Keep showing the workspace loader through
    // that window so there's no blank/login flash. A normal logged-out visitor
    // (no flag) just sees the login form without a loader.
    const justLoggedIn = sessionStorage.getItem("sb_just_logged_in") === "1";
    return justLoggedIn ? <FullScreenLoader /> : null;
  }

  if (user) return <Navigate to={getLandingPath(user, allowedPaths)} />;
  return children;
}
